

















import Vue, { PropType } from 'vue'
import mixin from '../mixins/notifications-mixin'
import Notification from '@/types/Notification.interface'
import PersonShowTitle from '@/components/PersonShowTitle.vue'
import csvhelper from '@/plugins/csvhelper'

export default Vue.extend({
    components: { PersonShowTitle },
    mixins: [mixin],
    props: {
        notification: {
            type: Object as PropType<Notification>,
            required: true
        }
    },
    data() {
        return {
            button: null
        }
    },
    mounted() {
        //  Set the notification button
        this.button = this.notificationButton(this.notification)
    },
    methods: {
        action(): void {
            //  Grab the action from our selected notification
            const action = this.notification.data.action

            //  If no action, do nothing
            if (!action) return

            //  Else, grab the params and exec
            const params = action.params
            const exec = action.exec

            //  If this params is a string and contains http, execute the link
            if (typeof params === 'string' && params.includes('http')) {
                window.open(params, this.$store.getters.isApp ? '_system' : '_blank')
            }

            //  Else, if the exec is for our csv report then open it
            else if (exec === 'importShowReport') {
                csvhelper.importShowReport(params)
            }
        },
        actionText(): string {
            //  If we don't have a selected notification then return null
            if (!this.notification) return null

            //  Get our exec from the notification
            const exec = window.getProps(
                this.notification,
                ['data', 'action', 'exec'],
                ''
            )

            //  Return the text
            return (
                {
                    downloadCsv: 'Download CSV',
                    importShowReport: 'Download Full Import Report'
                }[exec] || 'Action'
            )
        },
        displayButton(): boolean {
            //  If we are on mobile, don't show
            if (this.$store.getters.isMobile()) return false

            //  If we are on iOS, don't show
            if (this.$store.getters.isApp) return false

            //  If the actiontext does not match, don't show
            if (
                this.actionText !== 'Download CSV' &&
                this.actionText !== 'Download Full Import Report'
            )
                return false

            //  Else, return true
            return true
        }
    },
    watch: {
        notification() {
            //  Update the notification button
            this.button = this.notificationButton(this.notification)
        }
    }
})
